export const serviceStyleOpts = [
    { val: "boxed_drop", label: "Boxed meal - Drop and leave" },
    { val: "boxed", label: "Boxed meal - Caterer support" },
    { val: "buffet_self", label: "Buffet - Self service" },
    { val: "buffet_served", label: "Buffet - Catered service" },
    { val: "seated", label: "Sit down meal - Catered service" },
    { val: "canape", label: "Canape - Catered service" }
  ];

export const menuTypeOpts = [
    { val: "hot", label: "Hot where possible" },
    { val: "cold", label: "Cold" }
  ];

export const consumableOpts = [
    {
      val: "not_required",
      label: "Customer will provide plates, cutlery and consumables"
    },
    { val: "boxes", label: "Caterer to provide boxes" },
    { val: "all", label: "Caterer to provide boxes, cutlery and consumables" }
  ];

export const cleanUpOpts = [
    { val: "own", label: "own clean up only" },
    { val: "all", label: "customer and own clean up" }
  ];

export function getLabel(val, options) {
    try {
        return options.find((e) => e.val == val).label;
    } catch (err) { }
}

export default {
    serviceStyleOpts,
    menuTypeOpts,
    consumableOpts,
    cleanUpOpts,
    getLabel
}